import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'

const WHATSAPP_NUMBER = '5516993618378'
const WHATSAPP_MSG = encodeURIComponent(
    'Olá! Vim pelo site da Oxfield e gostaria de saber mais sobre os serviços.'
)

export default function WhatsAppButton() {
    return (
        <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`}
            target="_blank"
            rel="noreferrer"
            className="whatsapp-float"
            aria-label="Falar pelo WhatsApp"
        >
            <FaWhatsapp />
            <span className="whatsapp-label">Fale conosco</span>
        </a>
    )
}
